export const BaseUrl: string = 'https://bttf-server.toab.services';
//export const BaseUrl: string = 'http://10.10.220.45:9007';

export const imgUrl: string =
  'https://m360ict.s3.ap-south-1.amazonaws.com/toab-bttf';

//======== Auth context helper ========//
export const SET_SIGNUP_DATA = 'SET_SIGNUP_DATA';
export const EXHIBITOR_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const EXHIBITOR_USER_FAILED = 'EXHIBITOR_USER_FAILED';
export const USER_PROFILE_UPDATE = 'USER_PROFILE_UPDATE';
export const VISITOR_PROFILE_IMAGE_UPDATE = 'VISITOR_PROFILE_IMAGE_UPDATE';
export const B2B_PROFILE_IMAGE_UPDATE = 'B2B_PROFILE_IMAGE_UPDATE';
//======== visitor Auth context helper ========//

export const AUTH_VISITOR_USER_SUCCESS = 'AUTH_VISITOR_USER_SUCCESS';
export const AUTH_VISITOR_USER_FAILED = 'AUTH_VISITOR_USER_FAILED';

export const B2B_USER_SUCCESS = 'B2B_USER_SUCCESS';
export const B2B_USER_FAILED = 'B2B_USER_FAILED';
